import { AuthActionTypes } from './auth-actions';
import isPersian from '@utils/helpers/is-persian';
import nationalIdValidation from '@utils/helpers/national-id-validation';

export const initialState = {
  isLoggedIn: false,
  accessToken: undefined,
  tokenType: undefined,
  firstName: '',
  firstNameFlag: false,
  firstNameError: false,
  firstNameErrorMessage: 'نام خود را وارد کنید',
  lastName: '',
  lastNameFlag: false,
  lastNameError: false,
  lastNameErrorMessage: 'نام خانوادگی خود را وارد کنید',
  phoneNumber: undefined,
  avatar: undefined,
  userInfo: undefined,
  confirmLoading: false,
  verifyCode: undefined,
  sendVerificationLoading: false,
  sendVerificationLoadingByCall: false,
  codeRequestedType: 'sms',
  validationCodeLifetime: 0,
  showInfoLoading: false,
  isNumberValid: false,
  countDownReset: false,
  countDownOver: false,
  loginModal: false,
  callBackTypeId: undefined,
  redirectRoute: undefined,
  focus: false,
  isCompleted: false,
  completeProfileModal: false,
  walletCredit: undefined,
  orderTotalCount: 0,
  clientId: undefined,
  passportNumber: undefined,
  dateOfBirth: undefined,
  sex: undefined,
  sexFlag: false,
  sexError: false,
  sexErrorMessage: 'جنسیت خود را وارد کنید',
  email: undefined,
  dataLoading: false,
  submitLoading: false,
  provincesList: undefined,
  provincesListLoading: false,
  nationalId: '',
  nationalIdFlag: false,
  nationalIdError: false,
  nationalIdErrorMessage: '',
  routeKey: undefined,
  walletCreditLoading: true,
  orderTotalCountLoading: false,
  hasCallbackFunction: false,
  isAlreadyGetTheCodeFlag: false,
  isRetryingToGetNewCode: false,
  shebaNumber: null,
  unreadNotifications: 0,
  captchaToken: null,
};

function authReducer(state = initialState, action: any) {
  switch (action.type) {
    case AuthActionTypes.SAVE_TOKEN:

      return {
        ...state,
        accessToken: action?.data?.accessToken || undefined,
        tokenType: action?.data?.tokenType || undefined,
        confirmLoading: false,
        isLoggedIn: true,
      };

    case AuthActionTypes.SEND_VERIFICATION_CODE:
      let loading = {
        sendVerificationLoading: false,
        sendVerificationLoadingByCall: false,
      };
      if (action?.data?.type === 'call') {
        loading.sendVerificationLoadingByCall = true;
      } else {
        loading.sendVerificationLoading = true;
      }
      return {
        ...state,
        ...loading,
        codeRequestedType: action?.data?.type,
        isRetryingToGetNewCode: action?.data?.isRetryingToGetNewCode,
        captchaToken: action?.data?.token,
        focus: true,
      };

    case AuthActionTypes.CHECK_VERIFY_CODE:
      return {
        ...state,
        confirmLoading: true,
      };

    case AuthActionTypes.CHECK_SMS_CODE_AND_LOGIN:
      return {
        ...state,
        confirmLoading: true,
        verifyCode: action?.data?.verifyCode,
      };

    case AuthActionTypes.SET_CONFIRM_LOADING:
      return {
        ...state,
        confirmLoading: action?.data?.confirmLoading || false,
      };

    case AuthActionTypes.SET_CLIENT_INFO:
      return {
        ...state,
        firstName: action?.data?.clientInfo?.first_name || initialState.firstName,
        firstNameErrorMessage: !action?.data?.clientInfo?.first_name ? 'نام خود را وارد کنید' : !isPersian(action?.data?.clientInfo?.first_name) ? 'نام باید فارسی باشد' : '',
        firstNameError: !isPersian(action?.data?.clientInfo?.first_name) || !action?.data?.clientInfo?.first_name,
        firstNameFlag: !!action?.data?.clientInfo?.first_name,
        lastName: action?.data?.clientInfo?.last_name || initialState.lastName,
        lastNameErrorMessage: !action?.data?.clientInfo?.last_name ? 'نام خانوادگی خود را وارد کنید' : !isPersian(action?.data?.clientInfo?.last_name) ? 'نام خانوادگی باید فارسی باشد' : '',
        lastNameError: !isPersian(action?.data?.clientInfo?.last_name) || !action?.data?.clientInfo?.last_name,
        lastNameFlag: !!action?.data?.clientInfo?.last_name,
        phoneNumber: action?.data?.clientInfo?.mobile || initialState.phoneNumber,
        nationalId: action?.data?.clientInfo?.national_id || initialState.nationalId,
        nationalIdErrorMessage: action?.data?.clientInfo?.national_id && !nationalIdValidation(action?.data?.clientInfo?.national_id) ? 'کد ملی وارد شده صحیح نیست' : '',
        nationalIdFlag: !!action?.data?.clientInfo?.national_id,
        nationalIdError: action?.data?.clientInfo?.national_id ? !nationalIdValidation(action?.data?.clientInfo?.national_id) : false,
        passportNumber: action?.data?.clientInfo?.passport_number || initialState.passportNumber,
        dateOfBirth: action?.data?.clientInfo?.dob || initialState.dateOfBirth,
        sex: action?.data?.clientInfo?.sex || initialState.sex,
        sexErrorMessage: !action?.data?.clientInfo?.sex ? 'جنسیت خود را وارد کنید' : '',
        sexError: !action?.data?.clientInfo?.sex,
        sexFlag: !!action?.data?.clientInfo?.sex,
        email: action?.data?.clientInfo?.email || initialState.email,
        isLoggedIn: true,
        avatar: action?.data?.clientInfo?.avatar || initialState.avatar,
        userInfo: action?.data?.clientInfo?.first_name || action?.data?.clientInfo?.last_name ? `${action?.data?.clientInfo?.first_name} ${action?.data?.clientInfo?.last_name}` : action?.data?.clientInfo?.mobile,
        showInfoLoading: false,
        isCompleted: action?.data?.isCompleted || false,
        routeKey: action?.data?.clientInfo?.routeKey || initialState?.routeKey,
        shebaNumber: action?.data?.clientInfo?.sheba_number ? (action?.data?.clientInfo?.sheba_number).slice(2) : null,
        unreadNotifications: action?.data?.clientInfo?.unread_notifications,
      };

    case AuthActionTypes.GET_PROFILE_CLIENT_INFO:
      return {
        ...state,
        walletCreditLoading: true,
        orderTotalCountLoading: true,
      };

    case AuthActionTypes.SET_PROFILE_CLIENT_INFO:
      return {
        ...state,
        walletCredit: action?.data?.walletCredit,
        orderTotalCount: action?.data?.orderTotalCount,
        walletCreditLoading: false,
        orderTotalCountLoading: false,
      };

    case AuthActionTypes.SAVE_USER:
      return {
        ...state,
        firstName: action?.data?.firstName,
        lastName: action?.data?.lastName,
        phoneNumber: action?.data?.phoneNumber,
        isLoggedIn: true,
        avatar: action?.data?.avatar,
        userInfo: !action?.data?.firstName && !action?.data?.lastName ? action?.data?.phoneNumber : `${action?.data?.firstName} ${action?.data?.lastName}`,
        isCompleted: action?.data?.isCompleted || false,
      };

    case AuthActionTypes.SET_VALIDATION_CODE_LIFETIME:
      return {
        ...state,
        validationCodeLifetime: 30,
      };

    case AuthActionTypes.SET_VALIDATION_CODE_LOADING:
      return {
        ...state,
        sendVerificationLoading: action?.data?.sendVerificationLoading,
        sendVerificationLoadingByCall: action?.data?.sendVerificationLoading,
        isAlreadyGetTheCodeFlag: true,
        countDownOver: true,
        countDownReset: !state.countDownReset,
      };

    case AuthActionTypes.GET_CLIENT_INFO:
      return {
        ...state,
        showInfoLoading: true,
        completeProfileModal: false,
      };

    case AuthActionTypes.SET_SHOW_INFO_LOADING:
      return {
        ...state,
        showInfoLoading: false,
      };

    case AuthActionTypes.LOGOUT:
      return initialState;

    case AuthActionTypes.SET_CLIENT_MOBILE:
      return {
        ...state,
        phoneNumber: action?.data?.phoneNumber,
        isNumberValid: true,
      };

    case AuthActionTypes.SET_MOBILE_VALIDATION:
      return {
        ...state,
        isNumberValid: action?.data?.isNumberValid,
      };

    case AuthActionTypes.SET_VALIDATION_CODE:
      return {
        ...state,
        verifyCode: action?.data?.verifyCode,
      };

    case AuthActionTypes.SET_COUNT_DOWN_OVER:
      return {
        ...state,
        countDownOver: false,
        validationCodeLifetime: 0,
      };

    case AuthActionTypes.SET_LOGIN_MODAL:
      return {
        ...state,
        loginModal: action?.data?.loginModal,
        callBackTypeId: action?.data?.callBackTypeId,
        redirectRoute: action?.data?.redirectRoute || state?.redirectRoute,
        hasCallbackFunction: action?.data?.hasCallbackFunction,
        hasCostumeVerify: action?.data?.hasCostumeVerify,
      };

    case AuthActionTypes.SET_COMPLETE_PROFILE_MODAL:
      return {
        ...state,
        completeProfileModal: action?.data?.completeProfileModal,
      };

    case AuthActionTypes.SET_REDIRECT_ROUTE:
      return {
        ...state,
        redirectRoute: action?.data?.redirectRoute,
      };

    case AuthActionTypes.SET_SUBMIT_LOADING: {
      return {
        ...state,
        submitLoading: false,
      };
    }

    case AuthActionTypes.SET_PROVINCES_LIST: {
      let provinces = {
        '': 'نامشخص',
      };
      if (action?.data && action?.data.length > 0) {
        action?.data.map((item: any) => {
          provinces = Object.assign({}, provinces, {
            [item.id]: item.title,
          });
        });
      }
      return {
        ...state,
        provincesList: provinces,
        provincesListLoading: false,
      };
    }

    case AuthActionTypes.GET_PROVINCES_LIST: {
      return {
        ...state,
        provincesListLoading: true,
      };
    }

    case AuthActionTypes.EDIT_CLIENT_INFO: {
      return {
        ...state,
        submitLoading: true,
      };
    }

    case AuthActionTypes.SET_PROFILE_INFO: {
      return {
        ...state,
        [action?.data?.key]: action?.data?.info,
      };
    }

    case AuthActionTypes.SET_INITIAL_STATE:
      return {
        ...initialState,
        redirectRoute: action?.data?.redirectRoute,
        isLoggedIn: state?.isLoggedIn,
      };

    case AuthActionTypes.SET_FIRST_NAME:
      return {
        ...state,
        firstName: action?.data?.firstName,
        firstNameError: !isPersian(action?.data?.firstName) || !action?.data?.firstName,
        firstNameErrorMessage: !action?.data?.firstName ? 'نام خود را وارد کنید' : !isPersian(action?.data?.firstName) ? 'نام باید فارسی باشد' : '',
      };

    case AuthActionTypes.SET_LAST_NAME:
      return {
        ...state,
        lastName: action?.data?.lastName,
        lastNameError: !isPersian(action?.data?.lastName) || !action?.data?.lastName,
        lastNameErrorMessage: !isPersian(action?.data?.lastName) ? 'نام خانوادگی باید فارسی باشد' : !action?.data?.lastName ? 'نام خانوادگی خود را وارد کنید' : '',
      };

    case AuthActionTypes.SET_SEX:
      return {
        ...state,
        sex: action?.data?.sex,
        sexError: !action?.data?.sex,
        sexErrorMessage: !action?.data?.sex ? 'جنسیت خود را وارد کنید' : '',
      };

    case AuthActionTypes.SET_NATIONAL_ID:
      return {
        ...state,
        nationalId: action?.data?.nationalId,
        nationalIdError: action?.data?.nationalId && !nationalIdValidation(action?.data?.nationalId),
        nationalIdErrorMessage: action?.data?.nationalId && (action?.data?.nationalId.length < 10 ? 'کد ملی باید 10 رقمی باشد' : !nationalIdValidation(action?.data?.nationalId) ? 'کد ملی وارد شده صحیح نیست' : ''),
      };

    case AuthActionTypes.CHECK_INFO_VALIDATION:
      return {
        ...state,
        firstNameError: !state.firstName || !isPersian(state.firstName),
        firstNameErrorMessage: !state?.firstName ? 'نام خود را وارد کنید' : !isPersian(state?.firstName) ? 'نام باید فارسی باشد' : '',
        lastNameError: !state.lastName || !isPersian(state.lastName),
        lastNameErrorMessage: !isPersian(state?.lastName) ? 'نام خانوادگی باید فارسی باشد' : !state?.lastName ? 'نام خانوادگی خود را وارد کنید' : '',
        sexError: !state.sex,
        sexErrorMessage: !state?.sex ? 'جنسیت خود را وارد کنید' : '',
      };

    case AuthActionTypes.SET_HAS_CALLBACK_FUNCTION:
      return {
        ...state,
        hasCallbackFunction: true,
      };

    case AuthActionTypes.COMPLETE_CLIENT_PROFILE: {
      return {
        ...state,
        submitLoading: true,
      };
    }

    default:
      return state;
  }
}

export default authReducer;
